<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <!-- Formulario para añadir un nuevo pago -->
        <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate *ngIf="loaded && !isCaseClosed() && !disableAnadirPago">
          <div class="row align-items-end">
            <div class="col-md-4 mb-2">
              <label for="selectConcepto" class="form-label" i18n>Concepto (*)</label>
              <select class="form-select" id="selectConcepto" name="concepto" #concepto="ngModel"
                [(ngModel)]="nuevoPago.concepto" required
                [ngClass]="{ 'is-invalid': (concepto.invalid && f.submitted) || (concepto.invalid && (concepto.dirty || concepto.touched))}">
                <option value="" disabled selected i18n>Seleccione</option>
                <option *ngFor="let c of conceptos" [value]="c">{{ formatConcepto(c) }}</option>
              </select>
            </div>

            <div class="col-md-4 mb-2">
              <label for="selectTipoReclamacion" class="form-label" i18n>Tipo (*)</label>
              <select class="form-select" id="selectTipoReclamacion" name="tipo_reclamacion" #tipo_reclamacion="ngModel"
                [(ngModel)]="nuevoPago.tipo_reclamacion" required
                [ngClass]="{ 'is-invalid': (tipo_reclamacion.invalid && f.submitted) || (tipo_reclamacion.invalid && (tipo_reclamacion.dirty || tipo_reclamacion.touched))}">
                <option value="" disabled selected i18n>Seleccione</option>
                <option value="DEMANDA" i18n>DEMANDA</option>
                <option value="RECONVENCION" i18n>RECONVENCIÓN</option>
              </select>
            </div>

            <div class="col-md-4 mb-2">
              <label for="selectParte" class="form-label" i18n>Parte (*)</label>
              <select class="form-select" id="selectParte" name="id_parte" #id_parte="ngModel"
                [(ngModel)]="nuevoPago.id_parte" required
                [ngClass]="{ 'is-invalid': (id_parte.invalid && f.submitted) || (id_parte.invalid && (id_parte.dirty || id_parte.touched))}">
                <option value="" disabled selected i18n>Seleccione</option>
                <option *ngFor="let parte of partes" [value]="parte.value">{{ parte.label }}</option>
              </select>
            </div>

            <div class="col-md-2 mb-4">
              <label for="inputImporte" class="form-label" i18n>Importe (*)</label>
              <input type="text" class="form-control" id="inputImporte" name="importe" #importe="ngModel"
                (focus)="onFocus('importe')" (blur)="onBlur('importe')" [(ngModel)]="nuevoPago.importe" required min="0">
            </div>

            <div class="col-md-2 mb-4">
              <label for="inputFecha" class="form-label" i18n>Fecha (*)</label>
              <input type="date" class="form-control" id="inputFecha" name="fecha" #fecha="ngModel"
                [(ngModel)]="nuevoPago.fecha" required
                [ngClass]="{ 'is-invalid': (fecha.invalid && f.submitted) || (fecha.invalid && (fecha.dirty || fecha.touched))}">
            </div>


            <div class="col-md-8 text-end mb-4">
              <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="f.invalid || disableOptions || disableAnadirPago"><span
                  i18n>Añadir Pago</span></button>
            </div>
          </div>
        </form>

        <!-- Tabla de pagos -->
        <app-advanced-table *ngIf="loaded" [tableData]="records" [columns]="columns" [pagination]="true"
          [pageSizeOptions]="pageSizeOptions" [hasRowSelection]="true" [isSearchable]="true"
          (search)="searchData($event)" [isSortable]="true" (sort)="onSort($event)" [buttonLink]="buttonLink" [disableOptions]="disableOptions || disableAnadirPago"
          [buttonTitle]="buttonTitle" (deleteClick)="openDeleteModal($event)">
        </app-advanced-table>

        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
          {{ error }}
        </ngb-alert>
      </div>
    </div>
  </div>
</div>


<!-- Modal para confirmar borrado -->
<div class="confirm-delete-modal" *ngIf="showConfirmDeleteModal">
  <div class="confirm-delete-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Confirmar Borrado</h5>
    </div>
    <div class="confirm-delete-modal-body">
      <p><span i18n>¿Estás seguro de que deseas borrar el pago de</span> {{ pagoToDelete?.importe }} €?</p>
    </div>
    <div class="confirm-delete-modal-footer">
      <button type="button" class="btn btn-danger waves-effect waves-light" style="margin-right: 20px;"
        (click)="confirmDelete()">
        <span class="btn-label"><i class="fe-trash"></i></span><span i18n>Borrar</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeDeleteModal()">
        <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>